import { parseCountry, CountryData } from 'react-international-phone';

// יצירת רשימת מדינות מותאמת אישית עם מסכה ארוכה יותר
export const createCustomCountries = (countries: CountryData[]): CountryData[] => {
    return countries.map((countryData: CountryData) => {
        const parsed = parseCountry(countryData);
        // המבנה: [name, iso2, dialCode, format, priority?, areaCodes?]
        // המסכה: "(..) ..........." (2 בסוגריים + 11 ספרות = 13 ספרות)
        return [parsed.name, parsed.iso2, parsed.dialCode, "(..) ...........", 0] as CountryData;
    });
};

